export const reasons = {
  CreatedByError: 'created_by_error',
  EndOfContract: 'end_of_contract',
  ClientRequest: 'client_request',
  BillNotPaid: 'bill_not_paid',
} as const;

export type Reason = (typeof reasons)[keyof typeof reasons];
export type ReasonKey = keyof typeof reasons;

export type ClosureRequest = {
  id?: string;
  reason: Reason;
  details?: string;
  status?: ClosureRequestStatus;
  approved_at?: string; // ISO date string
  anonymized_at?: string; // ISO date string
};

export const closureRequestStatuses = {
  Opened: 'OPENED', // Closure in progress
  Approved: 'APPROVED', // Partner closure approved => waiting for anonymisation
  Anonymized: 'ANONYMIZED', // Partner anonymised
} as const;

export type ClosureRequestStatus =
  (typeof closureRequestStatuses)[keyof typeof closureRequestStatuses];
export type ClosureRequestStatusKey = keyof typeof closureRequestStatuses;
